module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "blog__filters"
  }, [_c('li', {
    staticClass: "blog__filter",
    class: _vm.noActiveFilter
  }, [_c('router-link', {
    staticClass: "blog__filter--link",
    attrs: {
      "to": "/blogue"
    }
  }, [_vm._v(_vm._s('Tous'))])], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('router-link', {
      class: ("blog__filter blog__filter--" + (category.name)),
      attrs: {
        "to": ("/blogue/categorie/" + (category.name)),
        "tag": "li"
      }
    }, [_c('a', {
      staticClass: "blog__filter--link"
    }, [_c('icon', {
      attrs: {
        "id": category.name
      }
    }), _c('span', {
      staticClass: "blog__filter--label"
    }, [_vm._v(_vm._s(category.label))])], 1)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ec3995e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/BlogFilters.vue
// module id = 634
// module chunks = 1